import React from 'react';
import PropTypes from 'prop-types';

export default function TopicItem({ topic }) {
  return (
    <div key={topic.id} className="mb-3 p-3 rounded bg-gray-100 fw-semibold">
      <div className="icon-with-text">
        <i
          className="picture-icon"
          style={topic.attributes.icon ? { backgroundImage: `url(${topic.attributes.icon})` } : {}}
        />
        <div className="text-content">
          {topic.attributes.title}
        </div>
      </div>
    </div>
  );
}

TopicItem.propTypes = {
  topic: PropTypes.object.isRequired,
};
